import Banner from '@/components/Banner2';
import Advantages from '@/components/Advantages/index.vue';
import Cases from '@/components/Cases/index.vue';
import Function from './components/Function.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Advantages,
    Cases,
    Function,
    Appointment2
  },
  data() {
    return {
      imageUrl: require('@/assets/images/service/shortsPlatform/shortsPlatform-banner.png'),
      bannerTitle: '短视频平台',
      bannerText: '同花顺AI短视频平台作为智能化的短视频生产工具，其内容框架由金融专家预设，经过超长时间和庞大金融语料的训练，最终利用数据可视化及虚拟人播报等技术，实现了短视频的自动化生产。该平台的出现，打破了短视频制作的技术壁垒，让零基础的内容生产者像做PPT一样，通过简单的拖拽和拼装，即可批量产出视频内容，并在云端实现视频的自动化生产与推送。',
      caseText: '他们都在用同花顺短视屏平台，让短视频制作变得更加简单、智能。',
      adsList: [{
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-capacity.png'),
        title: '提供一站式创作能力',
        desc: '内置丰富的素材、数据及可视化组件'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-experience.png'),
        title: '超低门槛的使用体验',
        desc: '操作简单，零基础也可轻松胜任'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-technology.png'),
        title: '领先的语言生成技术',
        desc: '融合先进的自然语言处理及知识图谱能力'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-3DVtuber.png'),
        title: '3D虚拟人形象',
        desc: '灵活定制个性化3D虚拟人形象'
      }]
    };
  }
};